// extracted by mini-css-extract-plugin
export var barContainer = "_2v-0";
export var extraThin = "_2v-3";
export var fillBar = "_2v-6";
export var fillContainer = "_2v-4";
export var overflow = "_2v-8";
export var overflowContainer = "_2v-5";
export var regular = "_2v-7";
export var thick = "_2v-1";
export var thin = "_2v-2";